import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { AppSettings } from 'src/app/shared/AppSettings';
import { UnitItemModel } from 'src/app/models/UnitItemModel';


@Injectable({
    providedIn: 'root'
})

export class UnitItemService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/UnitItemModel';

    getAllData() {
        return this.http.get<UnitItemModel[]>(this.baseurl + this.pathName).pipe(shareReplay(1));
    }
    
    getActiveDatas() {
        return this.http.get<UnitItemModel[]>(this.baseurl + this.pathName + '/GetActiveDatas' ).pipe(shareReplay(1));
    }
    getItemUnit(itemUnit:string,shopID:string) {
        return this.http.get<UnitItemModel>(this.baseurl + this.pathName + '/GetItemUnit/'+itemUnit+'/'+shopID);
    }
    getDataById(id: string) {
        return this.http.get<UnitItemModel>(this.baseurl + this.pathName + '/' + id);
    }

}